import FolderList from './FolderList';
import FolderListContainer from './FolderList.container';
export default FolderListContainer(FolderList);

//# sourceMappingURL=index.js.map